import type { CreditsApi } from './types';

export async function getCreditsApi(): Promise<CreditsApi> {
	const { creditsApi } = (await import('./')) as {
		creditsApi: CreditsApi;
	};
	return creditsApi;
}
